import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import StyledMenu from '../StyledMenu.js';
import { CONNECTOR_TYPES } from '../../../constants.js';

const useStyles = makeStyles(() => ({
    menu: {
        padding: '12px',
    },
    content: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        maxWidth: '270px',
        justifyContent: 'center',
    },
    itemRenderer: {
        width: '80px',
        height: '56px',
        padding: '4px',
        borderStyle: 'solid',
        borderRadius: '5px',
        boxShadow: '0 0 0 2px #FFF',
        borderColor: '#FFF',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '&:hover': {
            borderStyle: 'solid',
            borderRadius: '5px',
            boxShadow: '0 0 0 2px #07767D33',
            borderColor: '#07767D88',
        },
    },
}));

const CONNECTOR_OPTIONS = [
    { connectorType: CONNECTOR_TYPES.LINE },
    { connectorType: CONNECTOR_TYPES.ARROW_OPEN },
    { connectorType: CONNECTOR_TYPES.ARROW_FILLED },
    { connectorType: CONNECTOR_TYPES.DOUBLE_ARROW_OPEN },
    { connectorType: CONNECTOR_TYPES.DOUBLE_ARROW_FILLED },
];

const ConnectorPreview = ({ connectorType }) => {
    const hasEndArrow = connectorType !== CONNECTOR_TYPES.LINE;
    const hasStartArrow = connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_OPEN || connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_FILLED;
    const isFilled = connectorType === CONNECTOR_TYPES.ARROW_FILLED || connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_FILLED;
    const uid = `prev-${connectorType}`;

    return (
        <svg width="72" height="30" viewBox="0 0 72 30">
            <defs>
                {hasEndArrow && (
                    <marker id={`${uid}-end`} markerWidth="10" markerHeight="7" refX="10" refY="3.5" orient="auto" markerUnits="strokeWidth">
                        {isFilled
                            ? <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
                            : <polyline points="0 0, 10 3.5, 0 7" fill="none" stroke="#333" strokeWidth="1" />
                        }
                    </marker>
                )}
                {hasStartArrow && (
                    <marker id={`${uid}-start`} markerWidth="10" markerHeight="7" refX="0" refY="3.5" orient="auto" markerUnits="strokeWidth">
                        {isFilled
                            ? <polygon points="10 0, 0 3.5, 10 7" fill="#333" />
                            : <polyline points="10 0, 0 3.5, 10 7" fill="none" stroke="#333" strokeWidth="1" />
                        }
                    </marker>
                )}
            </defs>
            <line
                x1={hasStartArrow ? 10 : 5}
                y1="15"
                x2={hasEndArrow ? 62 : 67}
                y2="15"
                stroke="#333"
                strokeWidth="2"
                markerEnd={hasEndArrow ? `url(#${uid}-end)` : undefined}
                markerStart={hasStartArrow ? `url(#${uid}-start)` : undefined}
            />
        </svg>
    );
};

const ConnectorSelector = ({ anchorConnectorTool, handleClose, handleSelection }) => {
    const classes = useStyles();

    return (
        <StyledMenu
            id='connector-menu'
            anchorEl={anchorConnectorTool}
            keepMounted
            open={Boolean(anchorConnectorTool)}
            onClose={handleClose}
        >
            <div className={classes.menu}>
                <div className={classes.content}>
                    {CONNECTOR_OPTIONS.map((opt, index) => (
                        <div
                            key={`connector-opt-${index}`}
                            className={classes.itemRenderer}
                            onClick={() => handleSelection(opt.connectorType)}
                        >
                            <ConnectorPreview connectorType={opt.connectorType} />
                        </div>
                    ))}
                </div>
            </div>
        </StyledMenu>
    );
};

export default ConnectorSelector;
